import { call, put } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'

import {
	getInvoicesForCheckoutFailure,
	getInvoicesForCheckoutSuccess,
} from '../reducer'
import { IInvoicesForCheckoutResponse } from '../types'

export function* getInvoicesForCheckoutSaga({ payload }: PayloadAction<string[]>) {
	try {
		const response: IInvoicesForCheckoutResponse = yield call(apiMiddleware, {
			url: app_config.services.getInvoicesForCheckout,
			method: 'POST',
			data: {
				invoiceIds: payload,
			},
		})

		yield put(getInvoicesForCheckoutSuccess(response))
	} catch (e) {
		yield put(getInvoicesForCheckoutFailure())

		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)
	}
}
